import {detect} from 'detect-browser'

const browser = detect();

window.browser = browser
window.triggerPopup = triggerPopup

window.addEventListener('DOMContentLoaded', () => {
	if (browser.name === 'ie' || browser.name === 'edge') {
		triggerPopup({
			hash: '#popup_browserWarning'
		});
	}
})

/************************************
 ** Trigger Popup Programmatically  **
 ************************************/
function triggerPopup(params) {
  /* ----------------------------------
  ----- Process Options ---------------
  ---------------------------------- */
	var defaults = {
		hash: '',
		data: '',
		callbackPopup: '',
		callbackPopupData: '',
		trigger: '',
		keyboard: false
	};
	var options = $.extend({}, defaults, params);
  /* ----------------------------------
  ----- Close Existing Popups ---------
  ---------------------------------- */
	if ($('.popup').length) {
		$('.popup').find('.popup-close').click();
	}
  /* ----------------------------------
  ----- Variables ---------------------
  ---------------------------------- */
	var $trigger = $(options.trigger);
	var keyboard = options.keyboard;
	var $data;
	var onPage = false;
	if (options.data === '') {
		$data = $(options.hash);
		onPage = true;
	} else {
		$data = $(options.data);
	}

	var $placeholder = $('<placeholder />').hide();
	var $popup = $('<div class="popup" />').hide();
	var $overlay = $('<div class="popup-overlay" />');
	var $content = $('<div class="popup-content" />');
	var $close = $('<div class="popup-close" tabindex="0"></div>');

  /* ----------------------------------
  ----- Local Functions ---------------
  ---------------------------------- */
	function openPopup() {
		var open = $.Event('popup:open', {
			target: $content
		});
		$popup.on('popup:open', function (event) {
			if (onPage) {
				$data.before($placeholder);
			}
			$content.append($close).append($data);
			$overlay.append($content);
			$(this).append($overlay);
			$('.pageWrap').addClass('is-blurred');
			$('html').addClass('no-scroll')
			$('html').addClass('popup-open');
			$(this).fadeIn(250);
			if (keyboard) {
				$content.attr('tabindex', 0).focus();
			}
		});
		$('.pageWrap').after($popup);
		$popup.trigger(open);
	}

	function closePopup() {
		var close = $.Event('popup:close', {
			target: $content
		});
		$popup.on('popup:close', function () {
			$popup.fadeOut(250, function () {
				if (onPage) {
					$placeholder.after($data);
					$placeholder.remove();
				}
				$popup.remove();
				if (options.callbackPopup !== '') {
					triggerPopup({
						hash: options.callbackPopup
					});
				}
				else if (options.callbackPopupData !== '') {
					triggerPopup({
						data: options.callbackPopupData
					});
				}
				else if ($trigger.length && $trigger.is('[data-callback-popup]')) {
					triggerPopup({
						hash: $trigger.attr('data-callback-popup')
					});
				}
				else if ($trigger.length && $trigger.is('[data-callback-popup-data]')) {
					triggerPopup({
						data: $trigger.attr('data-callback-popup-data')
					});
				}
			});
			$('.pageWrap').removeClass('is-blurred');
			$('html').removeClass('no-scroll');
			$('html').removeClass('popup-open');
		});
		$popup.trigger(close);
	}
  /* ----------------------------------
  ----- Set Specific Width ------------
  ---------------------------------- */
	if ($data.is('[data-width]')) {
		$content.css('width', $data.attr('data-width'));
	}
	if ($trigger.length && $trigger.is('[data-width]')) {
		$content.css('width', $trigger.attr('data-width'));
	}
  /* ----------------------------------
  ----- Set External Link -------------
  ---------------------------------- */
	if ($trigger.length && $trigger.is('[data-target]')) {
		var $exitLink = $data.find('.externalLink');
		$exitLink.attr('href', $trigger.attr('data-target'))
			.attr('target', '_blank')
			.click(function () {
				closePopup();
			});
	}
  /* ----------------------------------
  ----- Set Iframe Source -------------
  ---------------------------------- */
	if ($trigger.length && $trigger.is('[data-video]')) {
		var $frame = $data.find('iframe');
		$frame.attr('src', $trigger.attr('data-video'))
	}
  /* ----------------------------------
  ----- Popup Interactions ------------
  ---------------------------------- */
	if ($data.find('.js-closePopup').length) {
		$data.find('.js-closePopup').click(function (e) {
			e.preventDefault();
			closePopup();
			if (e.screenX == 0 && e.screenY == 0 && $trigger.length) {
				$trigger.attr('tabindex', 0).focus();
			}
		});
	}
	$close.click(function () {
		closePopup();
	});
	$close.keypress(function (e) {
		if (e.which == 13) {
			closePopup();
			if ($trigger.length) {
				$trigger.attr('tabindex', 0).focus();
			}
		}
	});
	$overlay.click(function (e) {
		var $target = $(e.target);
		if (!$target.closest('.popup-content').length) {
			closePopup();
		}
	});
	openPopup();
}